import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { legalConfig } from '../../config/legal-config';
import { ConsentUiService } from '../../services/consent-ui.service';
import { Observable } from 'rxjs';
import { UsersApiService } from '../../services/users-api.service';
import { AuthSessionService } from '../../services/auth-session.service';

type FooterAlertButton = {
  text: string;
  role?: 'cancel' | 'destructive';
  handler: () => void;
};

@Component({
  selector: 'app-legal-footer',
  templateUrl: './legal-footer.component.html',
  styleUrls: ['./legal-footer.component.scss'],
  standalone: false,
})
export class LegalFooterComponent {
  readonly config = legalConfig;
  private readonly consentUi = inject(ConsentUiService);
  private readonly usersApi = inject(UsersApiService);
  private readonly authSession = inject(AuthSessionService);
  private readonly router = inject(Router);
  readonly authenticated$: Observable<boolean> = this.authSession.authenticated$;
  collapsed = true;
  deleteAccountConfirmOpen = false;
  deleteAccountLoading = false;
  deleteAccountError = '';
  readonly deleteAccountButtons: FooterAlertButton[] = [
    {
      text: 'Cancel',
      role: 'cancel',
      handler: () => this.cancelDeleteAccount(),
    },
    {
      text: 'Delete',
      role: 'destructive',
      handler: () => this.confirmDeleteAccount(),
    },
  ];
  openCookiePreferences(): void {
    this.consentUi.openPreferences();
  }

  toggleCollapsed(): void {
    this.collapsed = !this.collapsed;
  }

  openDeleteAccountConfirm(): void {
    this.deleteAccountError = '';
    this.deleteAccountConfirmOpen = true;
  }

  cancelDeleteAccount(): void {
    if (this.deleteAccountLoading) {
      return;
    }

    this.deleteAccountConfirmOpen = false;
  }

  confirmDeleteAccount(): void {
    const token = this.authSession.getState().token;
    if (!token) {
      this.deleteAccountConfirmOpen = false;
      return;
    }

    this.deleteAccountLoading = true;
    this.deleteAccountError = '';

    this.usersApi.deleteMe(token).subscribe({
      next: () => {
        this.authSession.clearSession();
        localStorage.removeItem('noisy_user_age_guess');
        this.deleteAccountLoading = false;
        this.deleteAccountConfirmOpen = false;
        this.collapsed = true;
        void this.router.navigateByUrl('/privacy', { replaceUrl: true });
      },
      error: () => {
        this.deleteAccountLoading = false;
        this.deleteAccountError = 'Unable to delete your account right now.';
      },
    });
  }
}
